import React, { useEffect, useState, useRef } from "react";
import { useSearchParams, Link, Navigate, useLocation, useNavigate } from 'react-router-dom';
import Breadcrumbs from "@mui/material/Breadcrumbs";
import { Card, Grid } from "@material-ui/core";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import { Box, Typography } from "@mui/material";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { makeStyles } from "@mui/styles";
import List from "@mui/material/List";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemText from "@mui/material/ListItemText";
import { PRIMARY, WHITE } from "../styles/color";
import allProducts from "../Images/allProduct.png";
import searchResultIcon from "../Images/ic-search2.png";
import ProductCard from "../components/ProuctCard";
import offerImage from "../Images/%off.png";
import { useDispatch, useSelector } from "react-redux";
import API_URL from "../ServiceModule/Service";
import axios from "axios";
import {
  useGetAPIWithoutTokenQuery,
  usePostAddToCartWithTokenMutation,
  useRemoveFromCartWithTokenMutation,
} from "../Api/api";
import "../Shop/CSS/shop.css";
import {
  addToCart,
  removeFromCart,
  removeItemFromCart,
} from "../Features/services/cartSlice";
import { ADD_TO_CART, READ_NESTED_CATEGORIES, REMOVE_FROM_CART, CATEGORIES_PARENTDATA } from "../Api/apiConstant";
import debounce from "lodash.debounce";
import { CircularProgress } from "@material-ui/core";
import MovotoTop from "../components/MovotoTop";
import { useThemeColors } from "../Context/Theme";
import { renderPagination } from "../Utils/Pagination";
import { isMobile as isMob } from "../global/helpers";
import { toast, ToastContainer } from "react-toastify";
import CategoryList from "./CategoryList";
import { getLoggedIn, getToken, getUserId } from "../LoginModule/LoginUtility";


const useStyles = makeStyles((theme) => ({
  customBg: {
    backgroundColor: "#F5F6FA",
  },
  customButton: {
    backgroundColor: "#E1FCF3",
    color: "#07E098",
    height: "9%",
    width: "130px !important",
    minWidth: "130px",
    padding: "0",
    textAlign: "center",
  },
  select: {
    padding: "4px 12px",
    border: "1px solid #ccc",
    borderRadius: "6px",
    fontSize: "16px",
    backgroundColor: "#fff",
    cursor: "pointer",
  },
}));

const Shop = () => {
  const {
    primaryColor,
    secondaryColor,
    textColor,
    buttonColor,
    buttonTextColor,
    backgroundColor,
    logo,
    fontFamily,
  } = useThemeColors();
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [sortValue, setSortValue] = useState("Newest");
  const location = useLocation();
  const eventname = sessionStorage.getItem("event_name");

  const eventId = sessionStorage.getItem("event_id");
  const seachParms = new URLSearchParams(location.search)
  const seachQuery = seachParms.get("search")
  const [selectedCategory, setSelectedCategory] = useState(null);
  const [productData, setProductData] = useState([]);
  const [allProduct, setAllProduct] = useState([]);
  const [selectedSku, setSelectedSku] = useState({});
  const [selectedSkuid, setSelectedSkuid] = useState({});
  const [page, setPage] = useState(1);
  const eventName = sessionStorage.getItem("eventName");
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const { results, selectedOption } = location.state || {};
  const [searchResults, setsearchResults] = useState([]);
  useEffect(() => {
    if (results) {
      setsearchResults(results);
    }
  }, [results]);

  const {
    data: categories,
    isError,
    isLoading,
    isSuccess,
  } = useGetAPIWithoutTokenQuery(
    `${READ_NESTED_CATEGORIES}?event_id=${eventId}`
  );
  
  const [AddToCart] = usePostAddToCartWithTokenMutation();
  const [RemoveFromCart] = useRemoveFromCartWithTokenMutation();
  const [Removecart] = useRemoveFromCartWithTokenMutation();

  const userId = getUserId();
  const token = getToken()
  const cartId = sessionStorage.getItem("cartId");
  const isLoggedIn = getLoggedIn();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const isTablet = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const ITEMS_PER_PAGE = 12;
  const cartItem = useSelector((state) => state.cart.items);
  const bottomRef = useRef(null);
  const [categoryHistory, setCategoryHistory] = useState([]);
  const [selectedCategoryName, setSelectedCategoryName] = useState("");
  const [currentCategories, setCurrentCategories] = useState([]);
    const {
      data: categoriesParentdata
    } = useGetAPIWithoutTokenQuery(
      `${CATEGORIES_PARENTDATA}?category_id=${selectedCategory }`, { skip: !selectedCategory || selectedCategory === "all"  }
    );

    
  const [blankQuantitySku, setBlankQuantitySku] = useState([])
  const [selectedSkuQuantity, setSelctedSkuQuantity] = useState([])


  const handleClickAll = () => {
    setSelectedCategory("all");
    setSelectedCategoryName("All Products");
    setCategoryHistory([]);
    setCurrentCategories(categories?.data || []);
  }
  
  const handleCategoryClick = (category, categoryId, categoryName, type) => {
    if (type === "arrowClick") {
      const selectedCategoryObj = categories?.data?.find(
        (cat) => cat.category_id === categoryId
      ) || category;
      if (selectedCategoryObj?.children?.length > 0) {  
        setCurrentCategories(selectedCategoryObj.children);
        setCategoryHistory((prevHistory) => [
          ...prevHistory,
          [selectedCategoryObj],
  
        ]);
      } else {
        setCurrentCategories([]);
      }
      setSelectedCategory(selectedCategoryObj?.children[0]?.category_id || categoryId);
      setSelectedCategoryName(selectedCategoryObj?.children[0]?.category_name || categoryName);
  
    } else if (category === "searchResults") {
      setSelectedCategory("searchResults");
      setSelectedCategoryName("Search Results");
    }
    else {
      setSelectedCategory(categoryId);
      setSelectedCategoryName(categoryName);
      setSortValue("");
      window.scrollTo(0, 0, { behavior: "smooth" });
    }
  };


  const handleBreadcrumbClick = (categoryId, categoryName) => {  
    setSelectedCategory(categoryId);
    setSelectedCategoryName(categoryName);
  
    setCategoryHistory(categoriesParentdata);
  };

  // const handleBreadcrumbClick = (categoryId, categoryName) => {
  //   // Find the index of the clicked category in the categoryHistory
  //   const historyIndex = categoryHistory.findIndex((history) =>
  //     history.some((category) => category.category_id === categoryId)
  //   );

  //   if (historyIndex === -1) {
  //     console.error("Category not found in history");
  //     return;
  //   }

  //   setSelectedCategory(categoryId);
  //   setSelectedCategoryName(categoryName);

  //   setCategoryHistory(categoryHistory.slice(0, historyIndex));

  //   if (historyIndex > 0) {
  //     const parentCategory = categoryHistory[historyIndex - 1].find(
  //       (category) =>
  //         category.children &&
  //         category.children.some((child) => child.category_id === categoryId)
  //     );
  //     if (parentCategory) {
  //       setCurrentCategories(parentCategory.children);
  //     }
  //   } else {
  //     setCurrentCategories(categories.data);
  //   }
  // };

  const breadcrumbs = [
    <Link
      to={`/events/${eventName}`}
      className="text-decoration-none font-size text-secondary"
      style={{ fontSize: isMobile ? "12px" : "17px" }}
      key="home"
    >
     {eventname}
    </Link>,
     selectedCategory === "searchResults" ? (
      <Typography
        key="search-results"
        color="text.primary"
        style={{ fontSize: isMobile ? "12px" : "17px" }}
      >
        Search Results
      </Typography>
    ) : (
      selectedCategory === 'all' && (
        <Typography
          key="current"
          color="text.primary"
          style={{ fontSize: isMobile ? "12px" : "17px" }}
        >
          {selectedCategoryName}
        </Typography>
      )
    ),
    // ...categoryHistory.map((category, index) => (
    //   <Link
    //     key={category?.category_id}
    //     onClick={() =>
    //       handleBreadcrumbClick(category?.category_id, category?.category_name)
    //     }
    //     className="text-decoration-none font-size text-secondary"
    //     style={{ fontSize: isMobile ? "12px" : "17px" }}
    //   >
    //     {category?.category_name}
    //   </Link>
    // )),
    
    // ...categoryHistory.flatMap((history, historyIndex) =>
    //   history.map((category, categoryIndex) => (
    //     <Link
    //       key={category?.category_id}
    //       onClick={() =>
    //         handleBreadcrumbClick(category?.category_id, category?.category_name)
    //       }
    //       className="text-decoration-none font-size text-secondary"
    //       style={{ fontSize: isMobile ? "12px" : "17px" }}
    //     >
    //       {category?.category_name}
    //     </Link>
    //   ))
    // ),
    // selectedCategoryName && (
    //   <Typography
    //     key="current"
    //     color="text.primary"
    //     style={{ fontSize: isMobile ? "12px" : "17px" }}
    //   >
    //     {selectedCategoryName}
    //   </Typography>
    // ),
  ];

   // Add parent categories to breadcrumbs
    if (categoriesParentdata && categoriesParentdata.length > 0 && selectedCategory !== "searchResults" && selectedCategory !== "all") {
      categoriesParentdata.forEach((category, index) => {
        breadcrumbs.push(
          <Typography key={index + 4} color="text.primary" style={{ fontSize: "17px", cursor: "pointer" }}
          onClick={() =>
                    handleBreadcrumbClick(category?.category_id, category?.category_name)
                  }          >
            {category.category_name}
          </Typography>
        );
      });
    }
    
  useEffect(() => {
    scrollToTop();
    setSelectedCategoryName("All Products");
    setCurrentCategories(categories?.data);
  }, [isSuccess]);

  const scrollToTop = () => {
    if (bottomRef.current) {
      bottomRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  useEffect(() => {
    if (location.state && location.state.category) {
      setSelectedCategory(location.state.category);
      // setSelectedCategoryName(location.state.categoryName);
      if (location.state.categoryName) {
        setSelectedCategoryName(location.state.categoryName);
        const selectedCategoryId = location.state.category;

      const findCategoryById = (categories, id, path = []) => {
        for (let category of categories) {
          const newPath = [...path, category];
          if (category.category_id === id) {
            return newPath;
          }
          if (category.children && category.children.length > 0) {
            const result = findCategoryById(category.children, id, newPath);
            if (result) return result;
          }
        }
        return null;
      };
  
      if (categories?.data) {
        const categoryPath = findCategoryById(categories.data, selectedCategoryId);  
        if (categoryPath) {
          const selectedCategoryObj = categoryPath[categoryPath.length - 1];  
          setCurrentCategories(categories?.data || []);
          // Filter category history data based on selected category and category history category ID match
          const filteredCategoryHistory = categoryPath.filter((category) => category.category_id !== selectedCategoryId);
          setCategoryHistory([filteredCategoryHistory]);
        } else {
          setCurrentCategories([]);
          setCategoryHistory([]);
        }
      }
      } else {
        setSelectedCategoryName("All Product");
        setCurrentCategories(categories?.data);
      }
    }
  }, [location.state]);





  const {
    data: AllProductData,
    isSuccess: AllProductSuccess,
    isError: AllProductError,
    isLoading: AllProductLoading,
  } = useGetAPIWithoutTokenQuery(
    `/api/product/readAllProducts?event_id=${eventId}&page=${page}&limit=${ITEMS_PER_PAGE}`, { refetchOnMountOrArgChange: true }
  );




  useEffect(() => {
    if (AllProductSuccess && !AllProductError && !AllProductLoading) {
      const productsToShow = AllProductData?.data
        ?.filter((product) => product?.skus?.some((sku) => sku?.sku_status === 1))
        .slice(0, 12);
      setAllProduct(productsToShow);
      setProductData(productsToShow);
    }
  }, [AllProductData, AllProductError, AllProductLoading, AllProductSuccess]);


  const totalPages = Math.ceil(selectedCategory === "all" ? AllProductData?.pagination?.totalRecords / ITEMS_PER_PAGE : productData?.length / ITEMS_PER_PAGE);
  const handlePageChange = (page) => {
    setPage(page);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };


  useEffect(() => {
    if (eventId && selectedCategory !== null) {
      if (selectedCategory === "all") {
        setProductData(allProduct);

      }
      else {
        const fetchProducts = async () => {
          setLoading(true);

          try {
            const categoryId = selectedCategory === "searchResults" ? searchResults[0].categories[0].category_id : selectedCategory;
            const response = await axios.get(
              `${API_URL}/api/product/getEventById?event_id=${eventId}&category_id=${categoryId}`
            );
            if (
              response.data.status === "false" ||
              response.data.message === "no products found"
            ) {
              setProductData([]);
              setLoading(false);

            } else {
              setProductData(response?.data?.data);
            }
          } catch (err) {
            setProductData([]);
            setLoading(false);

          } finally {
            setLoading(false);
          }
        };
        fetchProducts();
      }
    }
  }, [eventId, selectedCategory, allProduct, searchResults, setProductData]);


  const sortProductsByDiscountPrice = (order) => {
    // Handle sorting for productData if it exists
    if (productData && productData.length > 0) {
      const sortedProducts = [...productData].sort((a, b) => {
        const priceA = a.skus[0]?.discount_price || a.skus[0]?.regular_price || 0;
        const priceB = b.skus[0]?.discount_price || b.skus[0]?.regular_price || 0;
        return order === "asc" ? priceA - priceB : priceB - priceA;
      });
      setProductData(sortedProducts);
    }

    // Handle sorting for searchResults if it exists
    if (searchResults && searchResults.length > 0 && selectedCategory === 'searchResults') {
      const sortedSearchResults = [...searchResults].sort((a, b) => {
        const priceA = a.skus[0]?.discount_price || a.skus[0]?.regular_price || 0;
        const priceB = b.skus[0]?.discount_price || b.skus[0]?.regular_price || 0;
        return order === "asc" ? priceA - priceB : priceB - priceA;
      });
      setsearchResults(sortedSearchResults);
    }
  };

  const handleSortChange = (event) => {
    const value = event.target.value;
    setSortValue(value);

    if (value === "Price Ac") {
      sortProductsByDiscountPrice("asc");
    } else if (value === "Price Dc") {
      sortProductsByDiscountPrice("desc");
    } else if (value === "all") {
      setProductData(AllProductData.data);
      setSelectedCategory("all");
    }
  };

  const handleUnitSelect = (product, skuId) => {
    try {
      const selectedSku = product?.skus.find((sku) => sku?.sku_id === skuId);
      if (selectedSku) {
        setSelectedSku((prevSelectedSku) => ({
          ...prevSelectedSku,
          [product.product_id]: selectedSku,
        }));
      }
    } catch (error) {

    }
  };

  const handleChangeQuantity = async (value, product) => {
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if (value === "") {
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(prev => [...prev, selectedSkuData.sku_id])
      handleRemoveFromCart(product, 0);
      return;
    }
    if(value === 0){
      handleRemoveFromCart(product, 0);
      return;
    }
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    // Create the new cart item with the desired structure
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    setSelctedSkuQuantity(prev => {
      // Remove any previous entries with the same skuId
      const filtered = prev.filter(item => item.skuId !== selectedSkuData.sku_id);
      // Add the new one at the end
      return [...filtered, { skuId: selectedSkuData.sku_id, quantity: value }];
    });
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: value,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };
    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      // Update quantity and total price for an existing item
      newCartItem.quantity = value;
      newCartItem.total_price = (newCartItem.quantity * parseFloat(newCartItem.price)).toFixed(2);
    }

    // Redirect to login if the user is not logged in
    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // Dispatch the new cart item to Redux store
      // dispatch(
      //   addToCart({
      //     ...newCartItem,
      //   })
      // );
      // Make API call to add the item to the backend cart
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data?.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  }

  const handleAddToCart = async (product) => {
    {
      const currentDate = new Date();
      const preorderStartDate = new Date(
        sessionStorage.getItem("preorderStartDate")
      );
      const preorderEndDate = new Date(
        sessionStorage.getItem("preorderEndDate")
      );
      preorderStartDate.setUTCHours(0, 0, 0, 0);
      preorderEndDate.setUTCHours(23, 59, 59, 999);
      if (currentDate < preorderStartDate) {
        toast.error("Pre-order has not started yet.");
        return;
      } else if (currentDate > preorderEndDate) {
        toast.error(
          "The pre-order period has expired. You can't place an order."
        );
        return;
      }
    }
    const selectedSkuData = selectedSku[product.product_id] || product?.skus?.filter(i => i.sku_status === 1)?.[0];
    setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
    setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))

    // Create the new cart item with the desired structure
    const newCartItem = {
      product_id: product.product_id,
      sku_id: selectedSkuData?.sku_id,
      quantity: selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1,
      price: selectedSkuData?.discount_price || selectedSkuData?.regular_price,
      total_price: (
        (selectedSkuData?.discount_price || selectedSkuData?.regular_price) *
        (selectedSkuData?.quantity ? selectedSkuData.quantity + 1 : 1)
      ).toFixed(2),
      user_id: userId,
      event_id: eventId,
      status: "active",
      created_date: null,
      product_details: {
        product_id: product.product_id,
        product_name: product.product_name,
        product_description: product.product_description,
        state_tax: product.state_tax || "0.00",
        city_tax: product.city_tax || "0.00",
        brands: product.brands || [],
        categories: product.categories || [],
        productImg: product.productImg || [],
        skus: [selectedSkuData],
        categoryTax: product.categoryTax || [],
      },
    };




    const existingCartItem = cartItem.find(
      (item) =>
        item.product_id === newCartItem.product_id &&
        item.sku_id === newCartItem.sku_id
    );

    if (existingCartItem) {
      // Update quantity and total price for an existing item
      newCartItem.quantity = existingCartItem.quantity + 1;
      newCartItem.total_price = (
        newCartItem.quantity * parseFloat(newCartItem.price)
      ).toFixed(2);
    }

    // Redirect to login if the user is not logged in
    if (!isLoggedIn) {
      return navigate(`/events/${eventName}/login`);
    }

    try {
      // Dispatch the new cart item to Redux store
      // dispatch(
      //   addToCart({
      //     ...newCartItem,
      //   })
      // );

      // Make API call to add the item to the backend cart
      const { data } = await AddToCart({
        url: ADD_TO_CART,
        formData: {
          user_id: userId,
          items: [
            {
              product_id: newCartItem.product_id,
              sku_id: newCartItem.sku_id,
              quantity: newCartItem.quantity,
              price: newCartItem.price,
              total_price: newCartItem.total_price,
            },
          ],
          event_id: eventId,
        },
        token,
      });

      if (data.message === "Cart and CartItems processed successfully") {
        sessionStorage.setItem("cartId", data?.cart_id);
      }
    } catch (error) {
      console.error("Add to cart error:", error);
    }
  };

  const handleRemoveFromCart = async (product, value) => {
    const selectedSkuData = selectedSku[product.product_id] ? selectedSku[product.product_id] : product?.skus?.filter(i => i.sku_status === 1)?.[0];
    if(value !== 0){
      setSelctedSkuQuantity(selectedSkuQuantity.filter(n => n.skuId !== selectedSkuData.sku_id))
      setBlankQuantitySku(blankQuantitySku.filter(i => i !== selectedSkuData.sku_id))
    }
    const existingCartItem = cartItem?.find(
      (item) =>
        item.product_id === product?.product_id &&
        item.sku_id === selectedSkuData?.sku_id
    );
    const newCartItem = {
      product_id: existingCartItem?.product_id,
      sku_id: existingCartItem?.sku_id,
      bundle_id: existingCartItem?.bundle_id,
      quantity: value ? value : existingCartItem?.quantity > 1 ? existingCartItem?.quantity - 1 : 0,
      price:
        existingCartItem?.product_details?.skus[0]?.discount_price > 0
          ? existingCartItem?.product_details?.skus[0]?.discount_price
          : existingCartItem?.product_details?.skus[0]?.regular_price,
    };

    try {
      if (existingCartItem && existingCartItem?.quantity > 1 && value == undefined && value == null) {
        const previousQuantity = existingCartItem?.quantity;
        const newQuantity = previousQuantity - 1;
        // dispatch(removeFromCart({ ...product, quantity: newQuantity }));

        const { data } = await Removecart({
          url: ADD_TO_CART,
          formData: {
            user_id: userId,
            items: [newCartItem],
            event_id: eventId,
            callFrom: 'Remove'
          },
          token: token,
        });
      } else if (value == 0 || (existingCartItem && existingCartItem?.quantity === 1)) {
        // dispatch(removeItemFromCart({ itemId: existingCartItem?.product_id }));
        const { data } = await RemoveFromCart({
          url: REMOVE_FROM_CART,
          formData: {
            cart_id: cartId,
            product_id: existingCartItem?.product_id,
            sku_id: existingCartItem?.sku_id,
          },
          token: token,
        });
      }
    } catch (error) {

    }
  };

  const debouncedAddToCart = debounce(handleAddToCart, 300);
  const debouncedRemoveFromCart = debounce(handleRemoveFromCart, 300);


  return (
    <>
      <ToastContainer autoClose={2000} />

      <Navbar className="sticky-navbar" />

      <MovotoTop />

      {AllProductLoading ? (
        <div
          style={{
            height: "80vh",
            width: "100%",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <CircularProgress color="secondary" />
        </div>
      ) : (
        <div
          className="overflow-hidden"
          style={{
            background: backgroundColor || "#FAFAFA",
            marginTop: "15vh",
          }}
        >
          <Grid
            container
            xs={12}
            spacing={4}
            className="mb-3"
            style={{
              padding: "20px 15px 0px 55px",
              margin: "20px, 0px",
            }}
          >
            <Grid item xs={12} md={isMob() ? 3 : 6} className="" style={{ marginLeft: "0" }}>
              <Breadcrumbs
                separator={<NavigateNextIcon fontSize="small" />}
                aria-label="breadcrumb"
              >
                {breadcrumbs}
              </Breadcrumbs>
            </Grid>
            <Grid
              item
              xs={12}
              md={6}
              style={{ textAlign: isMobile ? "left" : "right" }}
            >

              <Typography
                variant="body1"
                component="span"
                style={{
                  marginRight: "17px",
                  fontWeight: "500",
                  fontSize: isMobile ? "12px" : "16px",
                  fontFamily
                }}
              >
                Sort By
              </Typography>
              <select
                id="sortSelect"
                className={isMob() ? "" : "shortContainer"}
                value={sortValue}
                onChange={handleSortChange}
                style={
                  isMob()
                    ? {
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      height: "5.5vh",
                      width: "50vw !important",
                      fontSize: "12px",
                      padding: "0 15px",
                      margin: "0",
                      fontFamily: fontFamily || "Poppins",
                      fontSize: "0.9rem",
                    }
                    : {
                      borderRadius: "5px",
                      border: "1px solid #ccc",
                      height: "3vh",
                      width: isMobile ? "100%" : "11vw",
                      fontSize: isMobile ? "12px" : "16px",
                      padding: "0 15px",
                      margin: "0",
                      fontFamily: fontFamily || "Poppins",
                      fontSize: "0.9rem",
                    }}


              >
                <option value="all" style={{ fontFamily }}>Relevance</option>{" "}
                <option value="Price Ac" style={{ fontFamily }}>Price (Low to High)</option>
                <option value="Price Dc" style={{ fontFamily }}>Price (High to Low)</option>
                {/* <option value="discount">Discount</option> */}
              </select>
            </Grid>
          </Grid>
          <Grid container spacing={2} className={isMob() ? "mx-2" : "mx-5"}>
            {(categories?.data?.length > 0 || seachQuery?.length > 0) && (

              <Grid
                item
                xs={3}
                sm={3}
                md={3}
                className="sticky-grid"
                style={{
                  maxWidth: "18%",
                  minWidth: "100",
                  marginBottom: "2em",
                  position: "relative",
                }}
              >
                <div
                  className="sticky-element"
                  style={{
                    width: "100%",
                    maxWidth: "263px",


                    backgroundColor: "white",
                    borderRadius: "21px",
                    position: "sticky",
                    top: "0",
                    zIndex: 100,
                    overflow: "hidden",
                    boxShadow:
                      "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                  }}
                >
                  <List
                    component="nav"
                    aria-label="main mailbox folders"
                    style={{
                      maxHeight: "135vh",
                      overflowY: "auto",
                      scrollbarWidth: "thin",
                    }}

                  >

                    {(seachQuery?.length > 0 || (selectedCategory === "searchResults" && seachQuery?.length > 0)) && (
                      <ListItemButton
                        selected={selectedCategory === "searchResults"}
                        onClick={() => handleCategoryClick("searchResults")}
                        style={
                          selectedCategory === "searchResults"
                            ? {
                              backgroundColor: primaryColor
                                ? `rgba(${parseInt(
                                  primaryColor.substring(1, 3),
                                  16
                                )}, ${parseInt(
                                  primaryColor.substring(3, 5),
                                  16
                                )}, ${parseInt(
                                  primaryColor.substring(5, 7),
                                  16
                                )}, 0.5)`
                                : "#FFF3F3",
                              color: textColor,
                              borderLeft: `6px solid ${primaryColor}`,
                              fontFamily
                            }
                            : { color: "black", fontFamily }
                        }
                        primaryTypographyProps={{
                          style: { fontFamily: fontFamily || 'Poppins, sans-serif' }
                        }}
                      >
                        <img
                          style={{


                            width: isMobile ? "100%" : "15%",
                            height: isMobile ? "10vh" : "6vh",
                            objectFit: "contain",
                          }}
                          src={searchResultIcon}
                          alt="All Products"
                        />
                        {!isMobile && (
                          <ListItemText
                            primary="Search Results"

                            sx={{
                              fontWeight: 500,
                              fontSize: "13px",
                              lineHeight: "20px",
                              padding: "0.8em",


                            }}
                            primaryTypographyProps={{
                              style: { fontFamily: fontFamily || 'Poppins, sans-serif' }
                            }}
                          />
                        )}
                      </ListItemButton>
                    )}

                    <CategoryList
                      categories={categories}
                      primaryColor={primaryColor}
                      textColor={textColor}
                      allProducts={allProducts}
                      isMobile={isMobile}
                      setSelectedCategory={setSelectedCategory}
                      selectedCategory={selectedCategory}
                      categoryHistory={categoryHistory}
                      setCategoryHistory={setCategoryHistory}
                      currentCategories={currentCategories}
                      handleCategoryClick={handleCategoryClick}
                      handleClickAll={handleClickAll}
                    />
                  </List>
                </div>
              </Grid>
            )}
            {/* Main Content */}

            <Grid item xs={7} sm={8} md={9} style={{ marginBottom: "2em" }}>
              <Grid container spacing={2}>
                {loading ? (
                  <Grid item xs={12} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                    <CircularProgress sx={{ color: "red", marginBottom: "1rem" }} />
                  </Grid>
                ) : selectedCategory === 'searchResults' && seachQuery?.length > 0 ? (
                  searchResults && searchResults?.filter(product =>
                    !product?.skus?.every(sku => sku?.sku_status === 0)
                  ).length > 0 ? (
                    searchResults?.filter(product =>
                      !product?.skus?.every(sku => sku?.sku_status === 0)
                    )?.map((product) => {
                      const selectedCartUnit = product.skus.find(
                        (sku) => sku.sku_id === selectedSku.sku_id
                      );
                      const selectedProduct = { ...product, skus: selectedSkuid };
                      return (
                        <Grid
                          item
                          xs={12}
                          sm={6}
                          md={3}
                          key={product?.id}
                          style={{ position: "relative" }}
                        >
                          <ProductCard
                            offer={product?.offer}
                            ageRestriction={
                              product?.categories[0]?.age_validation === "21"
                            }
                            productName={product?.product_name}
                            productType={product?.categories[0]?.category_name}
                            sku={product?.skus}
                            price={
                              selectedSku[product?.product_id]?.regular_price ||
                              product?.skus[0]?.regular_price
                            }
                            discount={
                              selectedSku[product.product_id]?.discount_amount ||
                              product?.skus[0]?.discount_price
                            }
                            offerDiscount={
                              selectedSku[product.product_id]?.discount_amount ||
                              product?.skus[0]?.discount_amount
                            }
                            product={product}
                            productId={product?.product_id}
                            image={product?.productImg?.[0]?.product_img}
                            rating={product?.rating || 4}
                            buttonText="ADD"
                            onClick={() => debouncedAddToCart(product)}
                            offerImage={offerImage}
                            addQuantity={() => debouncedAddToCart(product)}
                            removeQuantity={() =>
                              debouncedRemoveFromCart(product)
                            }
                            onUnitSelect={(prod, skuID) =>
                              handleUnitSelect(prod, skuID)
                            }
                            handleChangeQuantity={handleChangeQuantity}
                            blankQuantitySku={blankQuantitySku}
                            selectedSkuQuantity={selectedSkuQuantity}
                          />
                        </Grid>
                      );
                    })
                  ) : (
                    <Grid item xs={12}>
                      <Typography
                        variant="h6"
                        style={{
                          textAlign: "center",
                          padding: "20px 0",
                          color: "red",
                        }}
                      >
                        No products found
                      </Typography>
                    </Grid>
                  )
                ) : productData && productData?.filter(product =>
                  !product?.skus?.every(sku => sku?.sku_status === 0)
                ).length > 0 ? (
                  productData?.filter(product =>
                    !product?.skus?.every(sku => sku?.sku_status === 0)
                  )?.map((product) => {
                    const selectedCartUnit = product.skus.find(
                      (sku) => sku.sku_id === selectedSku.sku_id
                    );
                    const selectedProduct = { ...product, skus: selectedSkuid };

                    return (
                      <Grid
                        item
                        xs={12}
                        sm={6}
                        md={3}
                        key={product?.id}
                        style={{ position: "relative" }}
                      >
                        <ProductCard
                          offer={product?.offer}
                          ageRestriction={
                            product?.categories[0]?.age_validation === "21"
                          }
                          productName={product?.product_name}
                          productType={product?.categories[0]?.category_name}
                          sku={product?.skus}
                          price={
                            selectedSku[product?.product_id]?.regular_price ||
                            product?.skus[0]?.regular_price
                          }
                          discount={
                            selectedSku[product.product_id]?.discount_price ||
                            product?.skus[0]?.discount_price
                          }
                          offerDiscount={
                            selectedSku[product.product_id]?.discount_amount ||
                            product?.skus[0]?.discount_amount
                          }
                          product={product}
                          productId={product?.product_id}
                          image={product?.productImg?.[0]?.product_img}
                          rating={product?.rating || 4}
                          buttonText="ADD"
                          onClick={() => debouncedAddToCart(product)}
                          offerImage={offerImage}
                          addQuantity={() => debouncedAddToCart(product)}
                          removeQuantity={() =>
                            debouncedRemoveFromCart(product)
                          }
                          onUnitSelect={(prod, skuID) =>
                            handleUnitSelect(prod, skuID)
                          }
                          handleChangeQuantity={handleChangeQuantity}
                          blankQuantitySku={blankQuantitySku}
                          selectedSkuQuantity={selectedSkuQuantity}
                        />
                      </Grid>
                    );
                  })
                ) : (
                  <Grid item xs={12} style={{ marginBottom: "11em" }}>
                    <Typography
                      variant="h6"
                      style={{
                        textAlign: "center",
                        padding: "20px 0",
                        color: "red",
                      }}
                    >
                      No products found
                    </Typography>
                  </Grid>
                )}

                <Grid item xs={7} sm={8} md={12}>
                  {totalPages > 1 && (
                    <div
                      style={{
                        marginTop: "1vh",
                        marginBottom: "1vh",
                        height: "7vh",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",

                        width: '98%'
                      }}
                    >
                      {/* Previous Button */}
                      {/* <div
      style={{
        backgroundColor: page === 1 ? "grey" : "black",
        height: "70%",
        width: "7vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        borderRadius: "0.5em",
        fontWeight: "bold",
        cursor: page === 1 ? "not-allowed" : "pointer",
      }}
      onClick={() => {
        if (page > 1) setPage(page - 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      Previous
    </div> */}

                      {/* Render Pagination Numbers */}
                      {renderPagination({ page, totalPages, handlePageChange })}

                      {/* Next Button */}
                      {/* <div
      style={{
        backgroundColor: page === totalPages ? "grey" : "black",
        height: "70%",
        width: "7vw",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        color: "white",
        borderRadius: "0.5em",
        fontWeight: "bold",
        cursor: page === totalPages ? "not-allowed" : "pointer",
      }}
      onClick={() => {
        if (page < totalPages) setPage(page + 1);
        window.scrollTo({ top: 0, behavior: "smooth" });
      }}
    >
      Next
    </div> */}
                    </div>
                  )}
                </Grid>

              </Grid>


            </Grid>



          </Grid>

          <Footer />
        </div>
      )}
    </>
  );
};

export default Shop;
